import { useAccount, useWalletClient } from "wagmi"
import { getDrift } from "@/lib/utils/coins"
import { Address, parseEther } from "viem"
import { useEffect, useState } from "react"
import { CHAIN_ID, TOKEN_ADDRESSES } from "./constants"
import { ReadQuoter, DOPPLER_V3_ADDRESSES } from "doppler-v3-sdk"

type Quote = {
  gasEstimate: bigint
  amountOut: bigint
}

/**
 * This hook returns a quote object with the amount of coins the user would get in exchange of 1 USD.
 * It uses the ReadQuoter object from doppler.
 * @param tokenAddress coin's ERC20 address
 * @param ethPrice the current ETH price in USD
 * @returns Quote with amount of coins and gas estimate
 */
export function useUSDCoinQuote(tokenAddress: Address, ethPrice: number) {
  const [quote, setQuote] = useState<Quote | null>(null)
  const account = useAccount()
  const { data: walletClient } = useWalletClient(account)

  useEffect(() => {
    async function getQuote() {
      const drift = getDrift(CHAIN_ID, walletClient)
      const quoter = new ReadQuoter(
        DOPPLER_V3_ADDRESSES[CHAIN_ID].quoterV2,
        DOPPLER_V3_ADDRESSES[CHAIN_ID].univ2Router02,
        // @ts-ignore
        drift
      )

      const quote = await quoter.quoteExactInputV3({
        tokenIn: TOKEN_ADDRESSES[0] as `0x${string}`,
        tokenOut: tokenAddress,
        amountIn: parseEther(String(1 / ethPrice)),
        fee: 10000,
        sqrtPriceLimitX96: 0n,
      })
      setQuote(quote)
    }

    getQuote()
  }, [ethPrice, walletClient, tokenAddress])

  return quote
}
